import publicAxios from './PublicAxios';

/**
 * Chamadas públicas do Clube de parceiros: vitrine e cupons do cliente, e validação do parceiro.
 * Não usam o AxiosInstance do sistema: aqui não há login, só a sessão do aparelho (cliente) ou
 * do PIN (parceiro), enviada em cabeçalho próprio.
 */

const customerHeaders = (token) => ({ 'X-Club-Token': token });
const partnerHeaders = (token) => ({ 'X-Club-Partner-Token': token });

// Cliente
export const getClubStatus = (company) => publicAxios.get(`/api/club/${company}/status`);
export const getClubShowcase = (company) => publicAxios.get(`/api/club/${company}`);
export const requestClubCode = (company, document) => publicAxios.post(`/api/club/${company}/auth/code`, { document });
export const verifyClubCode = (company, document, code) => publicAxios.post(`/api/club/${company}/auth/verify`, { document, code });
export const getClubMe = (company, token) => publicAxios.get(`/api/club/${company}/me`, { headers: customerHeaders(token) });
export const getClubCoupons = (company, token) => publicAxios.get(`/api/club/${company}/me/coupons`, { headers: customerHeaders(token) });
export const generateClubCoupon = (company, token, offerId) => publicAxios.post(`/api/club/${company}/offers/${offerId}/coupon`, null, { headers: customerHeaders(token) });

// Parceiro
export const clubPartnerLogin = (accessUuid, pin) => publicAxios.post(`/api/club-partner/${accessUuid}/login`, { pin });
export const getClubPartnerMe = (accessUuid, token) => publicAxios.get(`/api/club-partner/${accessUuid}/me`, { headers: partnerHeaders(token) });
export const checkClubCoupon = (accessUuid, token, code) => publicAxios.get(`/api/club-partner/${accessUuid}/coupons/${encodeURIComponent(code)}`, { headers: partnerHeaders(token) });
export const redeemClubCoupon = (accessUuid, token, code) => publicAxios.post(`/api/club-partner/${accessUuid}/coupons/${encodeURIComponent(code)}/redeem`, null, { headers: partnerHeaders(token) });
export const getClubPartnerHistory = (accessUuid, token) => publicAxios.get(`/api/club-partner/${accessUuid}/history`, { headers: partnerHeaders(token) });

/**
 * Guarda a sessão do aparelho. Em try/catch porque o armazenamento pode estar bloqueado
 * (modo anônimo, cookies desligados) e isso não pode derrubar a página: a pessoa só
 * precisará confirmar de novo na próxima visita.
 */
export const readSession = (key) => {
    try {
        return localStorage.getItem(key) || '';
    } catch (error) {
        return '';
    }
};

export const writeSession = (key, value) => {
    try {
        if (value) localStorage.setItem(key, value);
        else localStorage.removeItem(key);
    } catch (error) {
        // Sem armazenamento: a sessão vale só até fechar a página.
    }
};
